import { defineComponent as _defineComponent } from 'vue'
import { watch, onMounted, onUnmounted, ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import Loader from '@/components/loader.vue'

import DateSelector from '@/components/meeting-request-2/date-selector.vue'
import TimeSelector from '@/components/meeting-request-2/time-selector.vue'
import MiniAuth from '@/components/meeting-request-2/mini-auth.vue'
import NoteToSender from '@/components/meeting-request-2/note-to-sender.vue'
import ContactDetails  from '@/components/meeting-request-2/contact-details.vue'
import ConfirmAndPay  from '@/components/meeting-request-2/meeting-confirm.vue'
import MeetingRequested  from '@/components/meeting-request-2/meeting-requested.vue'
import AccountToast from '@/components/account-toast.vue'

import OptOffer from '@/components/opt-offer.vue'
import { DataInstance, InviteLinks, Meetings, Userspaces } from '@busy-human/opt-library';
import { checkLoggedIn, getUserId, logout } from '@/util/auth';
import { httpsCallable } from 'firebase/functions';
import {functions} from '../util/firebase'
import { ISOTimeChunk, DayWithMomentChunk, RequestStage } from "@/components/meeting-request-2/meeting-request-types";

import { ISOTimestamp } from '@busy-human/gearbox'
import { Moment } from 'moment';

import { useMeetingRequestSchedule } from "@/components/meeting-request-2/schedule-mixin";
import { useUserspace } from '@/store/userspace';
// import { compileScript } from '@vue/compiler-sfc'; // wtf


export default /*#__PURE__*/_defineComponent({
  __name: 'meeting-request-2',
  setup(__props, { expose }) {
  expose();

const route = useRoute();
const router = useRouter();

//HTTP Functions
const sendMeetingRequest = httpsCallable<{meetingData: Meetings.Model, paymentId: string | null, uid?: string}, DataInstance<Meetings.Model>>(functions, 'sendMeetingRequest');


const noScroll = ref<boolean>(false)
const loading = ref<boolean>(true)
const stage = ref<RequestStage>(RequestStage.DATE);
const error = ref<string | null>(null);
const showToast = ref<boolean>(false)

//Meeting Creator User Variables
const user = ref<DataInstance<Userspaces.Model>  | null>(null);

//Invite Creator User Variables
const person = ref<DataInstance<Userspaces.Model> | null>(null);
const events = ref<ISOTimeChunk[]>([])

//Meeting Variables
const invite = ref<DataInstance<InviteLinks.Model> | null>(null);
const request = ref<Meetings.Model>(Meetings.Defaults());
const paymentMethodId = ref<string | null>(null)
const selectedDate = ref<Date|string>()

//State Control Variables
const selfMeeting = ref<boolean>(false)
const signedIn = ref<boolean>(false)

//Calendar Variables
const timesAvailable = ref<DayWithMomentChunk[]>([])
const timesAvailableForDay = ref<DayWithMomentChunk[]>([])
const env = ref(ENVIRONMENT)

onMounted(()=>{
    sessionStorage.setItem('stage','1')
    showToast.value = false;
})

onUnmounted(()=>{ 
    killMixin()
})

const userspace = useUserspace();

watch(()=> stage.value, stage =>{
    let stageToStore = stage.toString()
    // console.log("stage:",stage)
    sessionStorage.setItem('stage',stageToStore)
},{immediate: true})

watch(() => route.params.offerLink, async offerLink => {
    if(offerLink && !route.params.meetingId) {
        invite.value = await InviteLinks.Collection.fetchInviteForLink(offerLink as string);
        // console.log("Invite data:",invite.value)
        if(!invite.value) return;

        if(invite.value.collector) {
            request.value.collector = invite.value.collector;
            request.value.from = 'payer'
        }
        if(invite.value.payer) {
            request.value.payer = invite.value.payer;
            request.value.from = 'collector'
        }
        if(invite.value.startTime) {
            // We have functionality for pre-adding a start time to an invite link. The UI doesn't allow it yet, but it's here for when we add it.
            request.value.startTime = invite.value.startTime;
        }
        
        if(invite.value.contactInfo){
            request.value.sendersContactInfo = invite.value.contactInfo;
        }

        if(invite.value.paymentMethodPath){
            paymentMethodId.value = invite.value.paymentMethodPath
        }

        if(invite.value.note){
            request.value.sendersNote = invite.value.note
        }
        request.value.location = invite.value.location
        request.value.invite = invite.value.$id;
        request.value.price = invite.value.price;
        request.value.meetingLength = invite.value.minutes

        updateUserDetails()

        person.value = (await Userspaces.Collection.fetchDoc(invite.value.payer || invite.value.collector!)).data();
        const result = await updateUserAvailability(invite.value.collector || invite.value.payer);


        events.value = result
        loading.value = false;


        // console.log("INVITE:",invite)
        // console.log("Request:",request.value)

    }
}, {immediate: true})

const submitMeeting = async () => {
    try {
        updateUserDetails()

        loading.value = true
        error.value = null;

        // console.log("Request", request.value);
        // console.log("Payment Id", paymentMethodId.value)
        await sendMeetingRequest({meetingData: request.value, paymentId: paymentMethodId.value, uid: userspace.uid});

        stage.value = RequestStage.CONGRATS
        loading.value = false;

    } catch(e) {
        console.error(e);
        if(e instanceof Error) {
            error.value = e.message;
        } else {
            error.value = "Error while creating request."
        }
        loading.value = false
        return;
    }
}

//Helper Functions
const updateUserDetails = () => {
    // console.log("HIT UPDATE USERS DETAILS",invite.value,checkLoggedIn())
    if(checkLoggedIn() && invite.value) {
        let userId = userspace.uid;
        if(invite.value.payer){
            if(invite.value.payer == userId){
                selfMeeting.value = true
            }
            request.value.collector = userId;
        }else if(invite.value.collector){
            if(invite.value.collector == userId){
                selfMeeting.value = true
            }
            request.value.payer = userId;
        }
        user.value = userspace.user;
        if(!signedIn.value){
            showToast.value = true;
            signedIn.value = true;
            setTimeout(()=>{
                showToast.value = false;
            },5000)
        }
        
    }
}

const formatTime = (time: Date) =>{
    const timeOptions: Intl.DateTimeFormatOptions =  {hour: 'numeric', minute: "numeric"}
    return new Intl.DateTimeFormat('en-US', timeOptions).format(time)
}

const returnToInvite = () => {
    router.push({name: 'invite', params: { 'offerLink': route.params.offerLink }})
}

const routeTo = (route:string) =>{
    router.push(`/${route}`);
}

const setSelectedDate = (date: string | Date) =>{
    selectedDate.value = date
    // console.log("Selected:",selectedDate.value)
    let newStartTime = new Date(date).toISOString()
    meetingDate.value = new Date(date)
}

const updateTimesAvailable = (value: DayWithMomentChunk[])=>{
    timesAvailable.value = value
}

const meetingLength = ref<number>(0);

const { meetingDate, updateUserAvailability, killMixin } = useMeetingRequestSchedule({
    request: request,
    meetingLength: meetingLength,
    env: env,
});

const { checkPreviousDay } = useMeetingRequestSchedule(null)
const updateRequest = (meeting: Meetings.Model)=>{
    request.value = meeting
}



const __returned__ = { route, router, sendMeetingRequest, noScroll, loading, stage, error, showToast, user, person, events, invite, request, paymentMethodId, selectedDate, selfMeeting, signedIn, timesAvailable, timesAvailableForDay, env, userspace, submitMeeting, updateUserDetails, formatTime, returnToInvite, routeTo, setSelectedDate, updateTimesAvailable, meetingLength, meetingDate, updateUserAvailability, killMixin, checkPreviousDay, updateRequest, watch, onMounted, onUnmounted, ref, computed, useRoute, useRouter, Loader, DateSelector, TimeSelector, MiniAuth, NoteToSender, ContactDetails, ConfirmAndPay, MeetingRequested, AccountToast, OptOffer, DataInstance, InviteLinks, Meetings, Userspaces, checkLoggedIn, getUserId, logout, httpsCallable, functions, ISOTimeChunk, DayWithMomentChunk, RequestStage, ISOTimestamp, Moment, useMeetingRequestSchedule, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})